// SSR codes that mean the passenger travels with their own equipment
// (manual chair, battery-powered chair/scooter by battery type, portable oxygen)
export const EQUIPMENT_SSR_CODES = ["WCMP", "WCBD", "WCBW", "WCLB", "PPOC"];

// Portal and legacy app bookings set `equipment`, the pax app v2 lists items in
// paxAppMetadata.equipment, and SITA bookings only carry the SSR code.
export const hasEquipment = (booking) => {
    if (!booking) return false;
    if (booking.equipment === true) return true;
    if (Array.isArray(booking.paxAppMetadata?.equipment) && booking.paxAppMetadata.equipment.length > 0) return true;
    const assistance = Array.isArray(booking.assistance) ? booking.assistance : [];
    return assistance.some((code) =>
        typeof code === "string" && EQUIPMENT_SSR_CODES.some((ssr) => code.toUpperCase().includes(ssr))
    );
};
